// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14xDG","label":"styles_label__MYQq8"};